import { ReactElement, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu } from 'antd';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { TMarketType } from 'interfaces/sportsbook';
import { PickerButton } from 'components/PickerButton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { useMarketTypes } from 'newhooks/sportsbook/useMarketTypes';
import { setMarketType } from 'store/actions';
import { getMarketType } from 'store/selectors/sport-data';
import './index.less';

export const MarketsFilter = (): ReactElement | null => {
  const dispatch = useDispatch();
  const marketType = useSelector(getMarketType);

  const { params } = useSbRouteMatch();

  const { marketTypes, currentMarketType } = useMarketTypes();

  const setCurrentMarketType = useCallback(
    (menuItemKey: string) => {
      if (!menuItemKey || !marketTypes) {
        return;
      }

      const market = marketTypes.find(
        market => market.value === menuItemKey
      ) as TMarketType;

      if (JSON.stringify(currentMarketType) !== JSON.stringify(market)) {
        dispatch(setMarketType({ ...marketType, [params.sport]: market }));
      }
    },
    [marketType, currentMarketType, params.sport]
  );

  const menuItems = (marketTypes || []).map(({ value, label }) => {
    return { key: value, label: label };
  });

  if (marketTypes === null) {
    return null;
  }

  return !marketTypes ? (
    <div className="header-title">
      <Skeleton
        title={{
          style: { width: 70, margin: 0, marginRight: 4, height: 24 }
        }}
        paragraph={false}
        active
      />
    </div>
  ) : (
    <Dropdown
      className={`${
        menuItems?.length === 1 ? 'marketsFilter__disabled' : ''
      } marketsFilter`}
      overlayClassName={cc([
        'marketFilterDropdown',
        { 'marketFilterDropdown--mobile': isMobile() }
      ])}
      trigger={['click']}
      getPopupContainer={(triggerNode: HTMLElement) => {
        return (triggerNode.parentNode as HTMLElement) || document.body;
      }}
      overlay={
        <Menu
          selectedKeys={[currentMarketType?.value || '']}
          items={menuItems}
          onClick={menuItem => setCurrentMarketType(menuItem.key)}
        />
      }
    >
      <PickerButton>
        {marketTypes.find(({ value }) => value === currentMarketType?.value)
          ?.label || ''}
      </PickerButton>
    </Dropdown>
  );
};
